export default "__VITE_ASSET__fd492bbb__"